import { render, staticRenderFns } from "./LglRequirementReportBI.vue?vue&type=template&id=1a076280&"
import script from "./LglRequirementReportBI.vue?vue&type=script&lang=js&"
export * from "./LglRequirementReportBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports